import { render } from "./AllTransactionsList.vue?vue&type=template&id=2d07cbc4&scoped=true"
import script from "./AllTransactionsList.vue?vue&type=script&lang=js"
export * from "./AllTransactionsList.vue?vue&type=script&lang=js"

import "./AllTransactionsList.vue?vue&type=style&index=0&id=2d07cbc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d07cbc4"]])

export default __exports__